// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEntityAttributesInfoDto
 */
export interface IEntityAttributesInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IEntityAttributesInfoDto
     */
    entity_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IEntityAttributesInfoDto
     */
    attributes?: Array<string>;
}

/**
 * Check if a given object implements the IEntityAttributesInfoDto interface.
 */
export function instanceOfIEntityAttributesInfoDto(value: object): value is IEntityAttributesInfoDto {
    return true;
}

export function IEntityAttributesInfoDtoFromJSON(json: any): IEntityAttributesInfoDto {
    return IEntityAttributesInfoDtoFromJSONTyped(json, false);
}

export function IEntityAttributesInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEntityAttributesInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'entity_name': json['entity_name'] == null ? undefined : json['entity_name'],
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
    };
}

export function IEntityAttributesInfoDtoToJSON(json: any): IEntityAttributesInfoDto {
    return IEntityAttributesInfoDtoToJSONTyped(json, false);
}

export function IEntityAttributesInfoDtoToJSONTyped(value?: IEntityAttributesInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entity_name': value['entity_name'],
        'attributes': value['attributes'],
    };
}

